<template>
  <Modal
    v-if="showMe"
    :config='modalConfig.noticeCashIsaSuccess'
    @btn1Action="$emit('onViewNoticeClick')"
    @btn2Action="$emit('onGotoDashboardClick')"
  >
    <span slot='modalContent' class='font-weight-medium'
      style="display: block; margin-bottom: 30px;" data-qa="noticecashisasuccess-span-5vsth">
      {{ text }}
    </span>
  </Modal>
</template>

<script>

export default {
  name: 'NoticeCashIsaSuccess',
  props: {
    subtitle: String,
    text: String,
    viewButtonText: {
      type: String,
      default: function () {
        return this.$t('noticeCashIsa.common.button.viewNoticeDetails')
      }

    }
  },
  components: {
    Modal: () => import('@/components/common/Modal.vue')
  },
  data () {
    return {
      showMe: true,
      modalConfig: {
        noticeCashIsaSuccess: {
          enabled: true,
          title: this.subtitle,
          persistent: true,
          btn1Label: this.viewButtonText,
          btn2Label: this.$t('noticeCashIsa.common.button.gotoDashboard'),
          width: 600
        }
      }
    }
  }
}
</script>
